module.exports = __webpack_public_path__ + "img/bg21.f674212a.png";